import virtualClassroomStudentRoutes from 'modules/virtualClassrooms/common/routing/studentRoutes'

const routes = {
  root: `${virtualClassroomStudentRoutes.root}/details/participant/schedule`,
}

export default routes
